import { defineMessages } from 'react-intl'

export default defineMessages({
  update: {
    id: 'containers.CustomerOrderUpsertPage.components.Template.update',
    defaultMessage: 'Update',
  },
  submit: {
    id: 'containers.CustomerOrderUpsertPage.components.Template.submit',
    defaultMessage: 'Submit',
  },
})